export default {
    setFeeders(state, payload) {
        state.feeder = payload;
    }
}